// src/components/BlogTemplate.jsx

import React from "react";
import { Helmet } from "react-helmet";

// Assets
import blogHeaderImage from "../../../assets/images/blog/blog-zapierSupport-asset.jpg";
import blogAsset from "../../../assets/images/blog/blog-zapierApp-asset.jpg";

import "../blogTemplate.css";
import Footer from "../../Footer";

// Construct your blog data with an imported shareImage
const blogData = {
  title: "Meet Bumpups on Zapier",
  description:
    "Learn how to connect Bumpups video AI to 8,000+ apps via Zapier—auto-generate titles, descriptions, timestamps, and publish without writing a line of code.",
  shareImage: blogHeaderImage,
};

function BlogHeader() {
  return (
    <div className="blog-header">
      <div className="blog-topic-pill">Integrations</div>
      <h1>{blogData.title}</h1>
      <p className="blog-info">May 1, 2025 • 3 min read</p>
    </div>
  );
}

function BlogBody() {
  return (
    <div className="blog-body">
      {/* First image: full-width media */}
      <div className="blog-image-wrapper">
        <img
          src={blogData.shareImage}
          alt="Workflow automation overview"
          className="blog-picture"
        />
      </div>
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-text">
            <p>
              We’re thrilled to announce an exciting new partnership between <strong>Bumpups</strong> and <strong>Zapier</strong>—bringing you seamless, end-to-end video workflow automation like never before!
            </p>
          </div>
        </div>
      </div>
      {/* First text article */}
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-text">
            <p>
              In today’s digital workflows, automation makes a difference. If you create tutorials, demos, or lectures, tasks like writing titles, descriptions, and timestamps take time. With Bumpups and Zapier, you can automate these steps. Zapier connects that data to over 8,000 apps, so you can publish without manual effort.
            </p>
          </div>
        </div>
      </div>
      {/* Second text article */}
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-section-title">Why Automation Matters</div>
          <div className="blog-text">
          <p>
            Automating your video process ensures consistency and reduces manual tasks. Using Zapier, you create a workflow (Zap) once. After that, Bumpups AI will watch the video and generate any requested outputs, such as suggested chapters and hashtags. Zapier then sends this data to platforms like YouTube, Airtable, and Slack, keeping your content organized and synced across tools.
            </p>
          </div>
        </div>
      </div>

      {/* Second image: full-width media */}
      <div className="blog-image-wrapper">
        <img
          src={blogAsset}
          alt="Zap setup screenshot"
          className="blog-picture"
        />
      </div>

      {/* Final text article */}
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-text">
            <p>
              To begin, visit the{" "}
              <a href="https://zapier.com/apps/bumpups/integrations" target="_blank" rel="noopener noreferrer">
                Zapier integration page
              </a>
              . Connect your account and start automating with ready-made Zaps or create custom workflows. No coding needed—just set up your process and let Zapier and Bumpups handle the rest.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function BlogFooter() {
  return (
    <div>
      <footer className="blog-footer">
        <hr className="blog-footer-line" />
      </footer>
    </div>
  );
}

function blogZapierSupport() {
  return (
    <div className="blog-template">
      <Helmet>
        <title>{blogData.title} | Bumpups.com</title>
        <meta name="description" content={blogData.description} />

        {/* Open Graph meta tags for sharing */}
        <meta property="og:title" content={blogData.title} />
        <meta property="og:description" content={blogData.description} />
        <meta property="og:image" content={blogData.shareImage} />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blogData.title} />
        <meta name="twitter:description" content={blogData.description} />
        <meta name="twitter:image" content={blogData.shareImage} />
      </Helmet>
      <BlogHeader />
      <BlogBody />
      <BlogFooter />
      <Footer />
    </div>
  );
}

export default blogZapierSupport;
